// import Message from './Message';
// import Progress from './Progress';
// import axios from 'axios';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
// import recto from './src/img_card/recto_icon.png';
// C:\Users\admin\Desktop\hth_frontend\hth_frontend\src\img_card\recto_icon.png

const CardUpload = (props) => {
    CardUpload.propTypes = {
        setFilerecto: PropTypes.func,
        setFileverso: PropTypes.func
    };
    // const [file, setFile] = useState('');
    const [filerecto, setFilerecto] = useState('Téléchargez ici le recto, \n .png, .jpg, .jpeg , (Taille max : 5 MB)');
    const [fileverso, setFileverso] = useState('Téléchargez ici le verso, \n .png, .jpg, .jpeg , (Taille max : 5 MB)');
    // const [uploadedFile, setUploadedFile] = useState({});
    // const [message, setMessage] = useState('');
    // const [uploadPercentage, setUploadPercentage] = useState(0);

    const fileInputRef = useRef(null);

    const handleImageClick = () => {
        fileInputRef?.current?.click();
    };

    const fileInputRef2 = useRef(null);

    const handleImageClick2 = () => {
        fileInputRef2?.current?.click();
    };
    const onChangerecto = e => {
        console.log(e.target.files[0]);
        props.setFilerecto(e.target.files[0]);
        setFilerecto(e.target.files[0]?.name);
    };
    const onChangeverso = e => {
        console.log(e.target.files[0]);
        props.setFileverso(e.target.files[0]);
        setFileverso(e.target.files[0]?.name);
    };

    return (
        <div style={{display:'flex',flexDirection:'row',gap:'16px'}} >
            <input
                type='file'
                className='custom-file-input'
                id='customFile'
                accept=".png, .jpg, .jpeg"
                onChange={onChangerecto}
                readOnly
                ref={fileInputRef}
                style={{ display: 'none' }}
            />
            <div
                style={{width:'50%',cursor:'pointer'}}
                onClick={handleImageClick}
            >
                <form>
                    <div
                        className='UploadContainer'
                    >

                        <img
                            src="/img_card/recto_icon.png"
                            style={{width : '50px', height : '35px'}}
                        />
                        <label
                            style={{fontFamily : 'Arial, Helvetica, sans-serif', padding : '20px', paddingTop : '5px', textAlign : 'center'}}
                            className='custom-file-label'

                        >
                            {filerecto}
                        </label>
                    </div>
                </form>
            </div>

            <input
                type='file'
                className='custom-file-input'
                id='customFile2'
                accept=".png, .jpg, .jpeg"
                onChange={onChangeverso}
                readOnly
                ref={fileInputRef2}
                style={{ display: 'none' }}
            />
            <div
                style={{width:'50%',cursor:'pointer'}}
                onClick={handleImageClick2}
            >
                <form >
                    <div
                        className='UploadContainer'

                    >

                        <img
                            src="/img_card/verso_icon.png"
                            //onClick={handleImageClick}
                            style={{width : '50px', height : '35px'}}
                        />
                        <label
                            style={{fontFamily : 'Arial, Helvetica, sans-serif', padding : '20px', paddingTop : '5px', textAlign : 'center'}}
                            className='custom-file-label'

                        >
                            {fileverso}
                        </label>
                    </div>
                </form>
            </div>
        </div>
    );
};
export default CardUpload;
